export default class EmpresasEntity{
    
    unco: number;
    descripcionCorta: string;
    descripcionLarga: string;

    constructor() { }

    public getDescripcion(): string {
        return this.descripcionCorta != null && this.descripcionCorta.length > 0 ? this.descripcionCorta.trim() : this.descripcionLarga
    }
}